import type { DownloadContentType } from './DownloadTask';
import AssetsZipDownloadTask from './AssetsZipDownloadTask';
import MarkupsPSDDownloadTask from './MarkupsPSDDownloadTask';
import type { MessagingService } from '../services/MessagingService/types';
import type { DownloadInitializer } from '../services/AssetDownloadService/types';
import DownloadTask from './DownloadTask';

export type CreateAndObserveDownloadTaskParams = {
	id: string,
	contentType: DownloadContentType,
	messagingService: MessagingService,
	downloadInitializer: DownloadInitializer
};

export default class DownloadTaskFactory {
	static createAndObserve( {
		id, contentType, messagingService, downloadInitializer
	}: CreateAndObserveDownloadTaskParams ): DownloadTask {
		const DownloadTaskType = contentType === 'zip' ? AssetsZipDownloadTask : MarkupsPSDDownloadTask;

		const downloadTask = new DownloadTaskType( { id, messagingService, downloadInitializer } );
		downloadTask.observeDownloadFromBackend();
		return downloadTask;
	}
}
